module.exports = __webpack_public_path__ + "static/media/dodgem(18).a8e3cde0.PNG";